export default __webpack_public_path__ + "static/media/0.62.d4d7db2b.jpg";